import { useState } from 'react';
import { Button, Card, Group, Text, Title } from '@mantine/core';

/**
 * ÇÖKEN BÖLÜM — SÖZLEŞMENİN P11 MADDESİ (F4·B4 — gezinti kapanış turu 2).
 *
 * > **BOŞ BÖLÜM TEK SATIRA ÇÖKER:** başlık + sayı (0) + Ekle. İçerik
 * > girilince ya da Ekle'ye basılınca açılır; DOLU bölüm açık durur.
 *
 * Gerekçe: *"Etkilenen kişi kaydı yok"* için koca kart yer israfıdır —
 * detay sayfası boş bölümlerin kartlarıyla uzar ve dolu bölümler gözden
 * kaçar. Desen TÜM modüllerde geçerlidir; ilk uygulama olay detayıdır
 * (mevcut ekranlar toptan dönüştürülmez — sözleşmenin kendi kuralı).
 *
 * ⚠️ **Ekle bölümü AÇAR, kayıt açmaz:** açılan gövde bölümün kendi ekleme
 * denetimlerini (soluk satır · Ekle modalı) taşır — bileşen ikinci bir
 * yazma yolu kurmaz, kural bilmez.
 *
 * ⚠️ **Ekleyemeyen kullanıcıda çökük satır düğmesiz kalır** (başlık + 0):
 * boş bölümün varlığı okuyucudan saklanmaz (§2.40 — "görünmez ya da salt
 * okunur"), yalnız yer kaplamaz.
 */
export function CokenBolum({
  baslik,
  sayi,
  testId,
  ekleyebilir,
  ekleEtiketi = 'Ekle',
  children,
}: {
  baslik: string;
  /** Bölümdeki kayıt sayısı — 0'dan büyükse bölüm HEP açıktır. */
  sayi: number;
  testId: string;
  /** Ekleme denetimi görünsün mü (yetki SUNUCUDAN gelir — bileşen karar vermez). */
  ekleyebilir: boolean;
  ekleEtiketi?: string;
  /** Açık hâlin gövdesi — bölümün mevcut kartı olduğu gibi. */
  children: React.ReactNode;
}): React.JSX.Element {
  const [elleAcildi, setElleAcildi] = useState(false);
  if (sayi > 0 || elleAcildi) return <>{children}</>;
  return (
    <Card withBorder data-testid={`${testId}-cokuk`}>
      <Group justify="space-between">
        <Group gap="xs">
          <Title order={5}>{baslik}</Title>
          <Text size="sm" c="dimmed">
            (0)
          </Text>
        </Group>
        {ekleyebilir && (
          <Button
            size="compact-sm"
            variant="light"
            data-testid={`${testId}-ac`}
            onClick={() => setElleAcildi(true)}
          >
            {ekleEtiketi}
          </Button>
        )}
      </Group>
    </Card>
  );
}
